import { Middleware } from 'redux';

import {
  authApi,
  buildingsApi,
  cookieApi,
  decalApi,
  employeesApi,
  metricsApi,
  notificationsApi,
  onboardingApi,
  serviceInterruptionsApi,
  feedbackApi,
  orgApi,
  searchApi,
  userApi,
  usersApi,
  zonesApi,
  zoneCategoriesApi,
} from 'store/apis';

export const appMiddleware: Middleware<any>[] = [
  authApi.middleware,
  buildingsApi.middleware,
  cookieApi.middleware,
  decalApi.middleware,
  employeesApi.middleware,
  metricsApi.middleware,
  notificationsApi.middleware,
  onboardingApi.middleware,
  serviceInterruptionsApi.middleware,
  feedbackApi.middleware,
  orgApi.middleware,
  searchApi.middleware,
  userApi.middleware,
  usersApi.middleware,
  zonesApi.middleware,
  zoneCategoriesApi.middleware,
];
